export const STATUS = {
  CUSTOMER_PAID    : 'customer_paid',
  SELLER_CANCELLED : 'seller_cancelled',
  SELLER_SHIPPED   : 'seller_shipped',
  OPS_RECEIVED     : 'ops_received',
  OPS_REJECTED     : 'ops_rejected',
  OPS_ACCEPTED     : 'ops_accepted',
  EXPIRED          : 'expired'
}
